export const NavigationDropdownMenu =
    require('./NavigationDropdownMenu').default;

export default NavigationDropdownMenu;
